module.exports = __webpack_public_path__ + "media/images/favicon-16x16-78bf9dc54b1410beb98b33ca3f8a1c44.png";